import { matchPath } from "react-router-dom";
export type WorkspaceId =
  | "control"
  | "inventory"
  | "growth"
  | "insights"
  | "enquiries"
  | "administration";
type Role = "admin" | "SEO_ADMIN";
export interface WorkspaceRoute {
  path: string;
  label: string;
  workspace: WorkspaceId;
  roles: Role[];
  parent?: string;
  hidden?: boolean;
}
const both: Role[] = ["admin", "SEO_ADMIN"];
const admin: Role[] = ["admin"];
export const workspaces: { id: WorkspaceId; label: string }[] = [
  { id: "control", label: "Control Center" },
  { id: "inventory", label: "Inventory" },
  { id: "growth", label: "SEO & growth" },
  { id: "insights", label: "Insights" },
  { id: "enquiries", label: "Enquiries" },
  { id: "administration", label: "Administration" },
];
export const workspaceRoutes: WorkspaceRoute[] = [
  {
    path: "/control-center",
    label: "Overview",
    workspace: "control",
    roles: both,
  },
  {
    path: "/property-managment",
    label: "Listings",
    workspace: "inventory",
    roles: both,
  },
  {
    path: "/data-quality",
    label: "Quality",
    workspace: "inventory",
    roles: admin,
  },
  {
    path: "/reports-management",
    label: "Reports",
    workspace: "inventory",
    roles: admin,
  },
  {
    path: "/map-tools",
    label: "Locations",
    workspace: "inventory",
    roles: both,
  },
  {
    path: "/place-proposals",
    label: "Place review",
    workspace: "inventory",
    roles: both,
  },
  {
    path: "/properties",
    label: "Property map",
    workspace: "inventory",
    roles: both,
    hidden: true,
  },
  {
    path: "/property/:id",
    label: "Listing detail",
    workspace: "inventory",
    roles: both,
    parent: "/property-managment",
    hidden: true,
  },
  {
    path: "/slug-management",
    label: "Search pages",
    workspace: "growth",
    roles: both,
  },
  {
    path: "/cities-management",
    label: "City pages",
    workspace: "growth",
    roles: both,
  },
  {
    path: "/blogs-management",
    label: "SEO articles",
    workspace: "growth",
    roles: both,
  },
  { path: "/blog", label: "Blog studio", workspace: "growth", roles: admin },
  {
    path: "/featured-properties",
    label: "Featured",
    workspace: "growth",
    roles: both,
  },
  {
    path: "/sponsored-properties",
    label: "Sponsored",
    workspace: "growth",
    roles: both,
  },
  {
    path: "/handpicked-properties",
    label: "Curated groups",
    workspace: "growth",
    roles: both,
  },
  {
    path: "/property-group/:id",
    label: "Group detail",
    workspace: "growth",
    roles: both,
    parent: "/handpicked-properties",
    hidden: true,
  },
  {
    path: "/da/:id",
    label: "Group detail",
    workspace: "growth",
    roles: both,
    parent: "/handpicked-properties",
    hidden: true,
  },
  {
    path: "/dashboard/dashboard-overview",
    label: "Platform overview",
    workspace: "insights",
    roles: admin,
  },
  {
    path: "/dashboard/property-analytics",
    label: "Inventory analytics",
    workspace: "insights",
    roles: admin,
  },
  {
    path: "/dashboard/user-engagement",
    label: "Engagement",
    workspace: "insights",
    roles: admin,
  },
  {
    path: "/dashboard/property-engagement",
    label: "Property engagement",
    workspace: "insights",
    roles: admin,
  },
  { path: "/enquiries", label: "Board", workspace: "enquiries", roles: admin },
  {
    path: "/whatsapp-leads",
    label: "WhatsApp settings",
    workspace: "enquiries",
    roles: admin,
  },
  { path: "/users", label: "Users", workspace: "administration", roles: both },
  {
    path: "/agencies",
    label: "Organizations",
    workspace: "administration",
    roles: both,
  },
  {
    path: "/agencies/:id",
    label: "Organization detail",
    workspace: "administration",
    roles: both,
    parent: "/agencies",
    hidden: true,
  },
  {
    path: "/user-notifications",
    label: "Notifications",
    workspace: "administration",
    roles: both,
  },
  {
    path: "/dashboard/reconciliation",
    label: "Reconciliation",
    workspace: "administration",
    roles: admin,
  },
];
export const routeForPath = (pathname: string) =>
  workspaceRoutes.find((route) =>
    matchPath({ path: route.path, end: true }, pathname),
  );
export const visibleRoutes = (roles: readonly string[]) =>
  workspaceRoutes.filter(
    (route) =>
      !route.hidden && route.roles.some((role) => roles.includes(role)),
  );
